import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import Button from 'components/core/Button/Button'
import classNames from 'lib/util/classNames'
import noop from 'lib/util/noop'
import styles from './SimpleModal.module.scss'

/**
 * The `SimpleModal` element. Geared for the display
 * of 3rd party content (separate from the main modal
 * system). It utilizes the root node to display the element
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function SimpleModal (props) {
  const { children, className, color, onClose, size } = props
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        styles.container,
        styles[`color-${color}`],
        styles[`size-${normalizeSizeString(size)}`]
      ]),
    [className, color, size]
  )

  return (
    <div className={classNameOutput}>
      <div className={styles.background} aria-hidden="true" />
      <section className={styles.modal}>
        <Button
          className={styles.closeButton}
          type="symbol"
          icon="close"
          onClick={onClose}
        />
        {children}
      </section>
    </div>
  )
}

/** @type {object} */
SimpleModal.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
  size: PropTypes.string
}

/** @type {object} */
SimpleModal.defaultProps = {
  color: 'a',
  children: null,
  onClose: noop,
  size: 'standard'
}

// Memoize
export default memo(SimpleModal)
